import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=50156ccf&scoped=true"
import script from "./CustomerCard.vue?vue&type=script&lang=js"
export * from "./CustomerCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=50156ccf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50156ccf",
  null
  
)

export default component.exports